import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const StarFilledIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({}, attributes, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), __jsx("path", {
    d: "M3.6123 15.4427C3.22586 15.6413 2.78829 15.2942 2.86609 14.8508L3.69582 10.1213L0.173489 6.76462C-0.155692 6.45092 0.0147086 5.87737 0.455698 5.81472L5.35417 5.11885L7.53829 0.792305C7.73504 0.402565 8.26801 0.402565 8.46476 0.792305L10.6489 5.11885L15.5474 5.81472C15.9883 5.87737 16.1587 6.45092 15.8296 6.76462L12.3072 10.1213L13.137 14.8508C13.2148 15.2942 12.7772 15.6413 12.3908 15.4427L8.00153 13.1868L3.6123 15.4427Z",
    fill: color
  }));
};
export default StarFilledIcon;